const kmToMiles = (k: number) => k * 0.621371

export const kilometersToMiles = (k: string | number | null | undefined) => {
  if (!k) return 'unknown'

  return kmToMiles(parseFloat(k as string)).toFixed(2)
}

export const metersToMiles = (m: number) => kmToMiles(m / 1000)
